<template>
    <div>
        <!--
        <ul class="nav nav-tabs tab-deactive" style="background-color: #eff3f6; border-bottom-color: transparent !important;">
            <li v-for="tag in tags" class="nav-item" style="cursor: pointer;">
                <div :class="{'nav-link': true, 'active': tag.active}">{{ tag.label }}</div>
            </li>
        </ul>
        -->
        <b-card v-if="isLoaded">
            <div v-if="$store.state.isTablet" >
            <b-row style="font-weight: bold; text-align: start; margin-bottom:10px">
                <span style="text-align: center;">
                      {{$t('title')}}
                </span>
            </b-row>
            <b-row align-v="end">
                    <year-select @onchange="onYearChange"/>
                    <site-type-select v-if="siteTypes.length" @onchange="onSiteTypeChange"/>
                <b-col>
                    <region-multi-select
                    :selectedRegionId="selectedRegionId"
                    :regions="regions"
                    @oninput="selectedRegionId = ($event) ? ($event).id : null"
                />
                </b-col>
                <b-col>
                    <div style="width: 300px" class="placeholder-color-white">
                        <b-form-input v-model="searchInput" :placeholder="$t('siteSearchPlaceholder')" type="text" class="gray-input" style="margin-left: 10px"/>
                    </div>
                </b-col>
            </b-row>
        </div>  
            <div v-else >
                <b-row align-h="between" class="mt-2 mb-4">
                    <b-col style="font-weight: bold; text-align: start;">
                        <span style="text-align: center;">
                            {{$t('title')}}
                        </span>
                    </b-col>
                    <b-col cols="9" sm="9" md="7" lg="5" xl="6">
                        <b-row align-h="end" no-gutters>
                            <year-select @onchange="onYearChange" style="margin-right: 15px"/>
                            <site-type-select v-if="siteTypes.length" style="margin-right: 20px" @onchange="onSiteTypeChange"/>
                            <region-multi-select
                                :selectedRegionId="selectedRegionId"
                                :regions="regions"
                                @oninput="selectedRegionId = ($event) ? ($event).id : null"
                            />
                            <div style="width: 130px" class="placeholder-color-white">
                                <b-form-input v-model="searchInput" :placeholder="$t('siteSearchPlaceholder')" type="text" class="gray-input" style="margin-left: 10px"/>
                            </div>
                        </b-row>
                    </b-col>
                </b-row>
            </div>
            <div class="table-responsive scroll-content mt-3">
                <table class="table table-hover" style="table-layout: fixed; font-size: 0.875em;border-collapse: separate;border-spacing:0;">
                    <thead style="position: sticky;background-color: white;top: 0px;z-index:2">
                    <tr>
                        <th style="width: 10em">{{ $t('site') }}</th>
                        <th style="width: 10em">{{ $t('docCountColumn') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="documentSite in filteredDocuments" @click="routeToDocumentDetail(documentSite)" style="cursor: pointer;">
                        <td style="color: #007bff;">{{documentSite.name}}</td>
                        <td>{{documentSite.count}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <router-view/>
        </b-card>
    </div>
</template>

<script>
import _ from 'lodash';
import YearSelect from '../../../components/YearSelect';
import SiteTypeSelect from '../../../components/SiteTypeSelect';
import RegionMultiSelect from '../../../components/RegionMultiSelect';

export default {
    name: 'doc-summary',
    components: {RegionMultiSelect, SiteTypeSelect, YearSelect},
    data() {
        return {
            isLoaded: false,
            tempSites: [],
            documentSites: [],
            regions: [],
            selectedRegionId: null,
            selectedTypeId: null,
            searchInput: '',
            initialRoute: 'doc',
            tags: [
                {key: 'belgeler', label: 'Belgeler', active: true},
                {key: 'atikTakipFormu', label: 'Atık Takip Formu', active: false},
                {key: 'atikTeslimFormu', label: 'Atık Teslim Formu', active: false},
                {key: 'kimyasalMalzemeFormu', label: 'Kimyasal Malzeme Formu', active: false}
            ]
        };
    },
    methods: {
        onSiteTypeChange(siteTypeId) {
            this.selectedRegionId = null;
            this.selectedTypeId = siteTypeId;
        },
        routeToDocumentDetail(site) {
            this.$store.state.siteId = site ? site.site_id : null;
            let routeData = this.$router.resolve({
                name: 'site-files',
                params: {site_id: site.site_id},
                query: {year: this.year}
            });
            if (this.gbId(this.$store.state.user.customerId)) {
                window.open(routeData.href, '_blank');
            } else {
                this.$router.push({
                    name: 'site-files',
                    params: {site_id: site.site_id},
                    query: {year: this.year}
                });
            }
            /* this.$router.push({
                name: 'site-files',
                params: {site_id: site.site_id},
                query: {year: this.year}
            }); */
            return Promise.resolve();
        },
        routeTo() {
            this.$router.push({
                name: 'files',
                query: {year: this.year}
            });
            return Promise.resolve();
        },
        configureDocuments() {
            this.documentSites = _.map(this.documents, documentSite => {
                let foundItem = _.find(this.tempSites, {id: documentSite.site_id});
                if (foundItem) {
                    return {
                        ...documentSite,
                        code: foundItem.code,
                        siteGroupId: foundItem.siteGroupId,
                        name: foundItem.name
                    };
                } else {
                    return documentSite;
                }
            });
            return Promise.resolve(true);
        },
        init() {
            this.isLoaded = false;
            this.$Progress.start();
            this.regions = [{id: null, display_name: this.$t('allRegions')}, ...this.siteGroups];
            this.$store.state.year = this.route.query.year
                ? Number(this.route.query.year)
                : this.year;
            this.$store.state.siteId = this.route.params.site_id ? this.route.params.site_id : null;
            this.tempSites = this.sites;
            this.$store
                .dispatch('getDocumentCounts', this.year)
                .then(this.configureDocuments)
                .then(() => {
                    this.$Progress.finish();
                    this.isLoaded = true;
                });
        },
        onYearChange(newYear) {
            this.$store.state.year = newYear;
            this.$store
                .dispatch('getDocumentCounts', this.year)
                .then(this.configureDocuments)
                .then(this.routeTo)
                .then(() => {
                    this.isLoaded = true;
                });
        }
    },
    computed: {
        filteredDocuments() {
            if (this.searchInput.length <= 3) {
                let filteredSites = this.documentSites.filter(item => {
                    let found = _.find(this.sites, {id: item.site_id});
                    return (
                        this.textStartsWith(item.code + item.name, this.searchInput) &&
                        this.isRegionFound(this.selectedRegionId, item.siteGroupId) &&
                        (!this.selectedTypeId || found.typeId === this.selectedTypeId)
                    );
                });

                if (filteredSites.length) {
                    return filteredSites;
                }
            }
            return this.documentSites.filter(item => {
                let found = _.find(this.sites, {id: item.site_id});
                return (
                    this.isSearchTextFound(item.code + item.name, this.searchInput) &&
                    this.isRegionFound(this.selectedRegionId, item.siteGroupId) &&
                    (!this.selectedTypeId || found.typeId === this.selectedTypeId)
                );
            });
        }
    },
    created() {
        this.init();
    }
};
</script>
<style lang="scss">
.tab-deactive {
    .nav-link {
        background-color: #ddd;
    }
}
</style>

<i18n src="../../../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "title": "BELGELER",
            "docCountColumn": "Doküman Sayısı"
        },
        "en": {
            "title": "DOCUMENTS",
            "docCountColumn": "Documents"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Doc/Files/Summary.vue